export enum ListDateType {
    current_month = "current_month",
    custom = "custom",
    last_30 = "last_30",
    last_90 = "last_90",
    last_month = "last_month",
    this_year = "this_year"
}